import * as React from "react";
import { InvestigatorCardComponent } from "./InvestigatorCard";
import { IInvestigatorInPlay } from "./Scenario";
import { PlayerNavigatorComponent } from "./PlayerNavigator";

export interface IInvestigatorAreaProps {
    state: IInvestigatorInPlay;
    playerNumber: number;
    onChanged: () => void;
}
export class InvestigatorAreaComponent extends React.Component<IInvestigatorAreaProps, any> {
    render() {
       
        return (
            <div className="investigator-area">
                <div className="investigator-heading">
                    <div className="investigator-col">
                        <InvestigatorCardComponent investigator={this.props.state} onChanged={() => {this.props.onChanged();}} />
                    </div>
                    <div className="clearfix"/>
                </div>
                <PlayerNavigatorComponent state={this.props.state} onChanged={() => this.props.onChanged()} />
            </div>
        );
    }

}
